import React from 'react';

const Multiple = ({ className }) => {
    return (
        <svg
            className={className}
            width={200}
            height={117}
            viewBox="0 0 200 117"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            //{...props}
        >
            <g clipPath="url(#clip0_46_1429)">
            <rect width={200} height={117} rx={6} fill="#F4F0EC" />
            <path
                d="M29 73C29 71.3431 30.3431 70 32 70H58C59.6569 70 61 71.3431 61 73V94C61 95.6569 59.6569 97 58 97H32C30.3431 97 29 95.6569 29 94V73Z"
                fill="white"
            />
            <path d="M35.9782 78.5H61H35.9782Z" fill="white" />
            <path
                d="M34 92H47"
                stroke="#E66819"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M55 92H56"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M40.0224 80.5332L37.3762 83.519C36.5047 84.5023 37.2443 86 38.6015 86H51.3993C52.6273 86 53.3966 84.7455 52.7862 83.7382L49.7692 78.7599C49.2266 77.8647 47.9154 77.7355 47.189 78.5056L45.1387 80.6797C44.5732 81.2794 43.61 81.3559 42.9466 80.8538L42.2467 80.3241C41.5685 79.8107 40.5804 79.9035 40.0224 80.5332Z"
                fill="#818181"
            />
            <path
                d="M41 78C42.1046 78 43 77.1046 43 76C43 74.8954 42.1046 74 41 74C39.8954 74 39 74.8954 39 76C39 77.1046 39.8954 78 41 78Z"
                fill="#E66819"
            />
            <path
                d="M29 103C29 101.343 30.3431 100 32 100H58C59.6569 100 61 101.343 61 103V124C61 125.657 59.6569 127 58 127H32C30.3431 127 29 125.657 29 124V103Z"
                fill="#404040"
            />
            <path d="M35.9782 108.5H61H35.9782Z" fill="#404040" />
            <path
                d="M40.0224 110.533L37.3762 113.519C36.5047 114.502 37.2443 116 38.6015 116H51.3993C52.6273 116 53.3966 114.745 52.7862 113.738L49.7692 108.76C49.2266 107.865 47.9154 107.735 47.189 108.506L45.1387 110.68C44.5732 111.279 43.61 111.356 42.9466 110.854L42.2467 110.324C41.5685 109.811 40.5804 109.904 40.0224 110.533Z"
                fill="#818181"
            />
            <path
                d="M41 108C42.1046 108 43 107.105 43 106C43 104.895 42.1046 104 41 104C39.8954 104 39 104.895 39 106C39 107.105 39.8954 108 41 108Z"
                fill="#E66819"
            />
            <path
                d="M65 73C65 71.3431 66.3431 70 68 70H94C95.6569 70 97 71.3431 97 73V94C97 95.6569 95.6569 97 94 97H68C66.3431 97 65 95.6569 65 94V73Z"
                fill="white"
            />
            <path d="M71.9782 78.5H97H71.9782Z" fill="white" />
            <path
                d="M70 92H83"
                stroke="#E66819"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M91 92H92"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M76.0224 80.5332L73.3762 83.519C72.5047 84.5023 73.2443 86 74.6015 86H87.3993C88.6273 86 89.3966 84.7455 88.7862 83.7382L85.7692 78.7599C85.2266 77.8647 83.9154 77.7355 83.189 78.5056L81.1387 80.6797C80.5732 81.2794 79.61 81.3559 78.9466 80.8538L78.2467 80.3241C77.5685 79.8107 76.5804 79.9035 76.0224 80.5332Z"
                fill="#818181"
            />
            <path
                d="M77 78C78.1046 78 79 77.1046 79 76C79 74.8954 78.1046 74 77 74C75.8954 74 75 74.8954 75 76C75 77.1046 75.8954 78 77 78Z"
                fill="#E66819"
            />
            <path
                d="M65 103C65 101.343 66.3431 100 68 100H94C95.6569 100 97 101.343 97 103V124C97 125.657 95.6569 127 94 127H68C66.3431 127 65 125.657 65 124V103Z"
                fill="#404040"
            />
            <path d="M71.9782 108.5H97H71.9782Z" fill="#404040" />
            <path
                d="M76.0224 110.533L73.3762 113.519C72.5047 114.502 73.2443 116 74.6015 116H87.3993C88.6273 116 89.3966 114.745 88.7862 113.738L85.7692 108.76C85.2266 107.865 83.9154 107.735 83.189 108.506L81.1387 110.68C80.5732 111.279 79.61 111.356 78.9466 110.854L78.2467 110.324C77.5685 109.811 76.5804 109.904 76.0224 110.533Z"
                fill="#818181"
            />
            <path
                d="M77 108C78.1046 108 79 107.105 79 106C79 104.895 78.1046 104 77 104C75.8954 104 75 104.895 75 106C75 107.105 75.8954 108 77 108Z"
                fill="#E66819"
            />
            <path
                d="M139 73C139 71.3431 140.343 70 142 70H168C169.657 70 171 71.3431 171 73V94C171 95.6569 169.657 97 168 97H142C140.343 97 139 95.6569 139 94V73Z"
                fill="white"
            />
            <path d="M145.978 78.5H171H145.978Z" fill="white" />
            <path
                d="M144 92H157"
                stroke="#E66819"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M165 92H166"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M150.022 80.5332L147.376 83.519C146.505 84.5023 147.244 86 148.601 86H161.399C162.627 86 163.397 84.7455 162.786 83.7382L159.769 78.7599C159.227 77.8647 157.915 77.7355 157.189 78.5056L155.139 80.6797C154.573 81.2794 153.61 81.3559 152.947 80.8538L152.247 80.3241C151.568 79.8107 150.58 79.9035 150.022 80.5332Z"
                fill="#818181"
            />
            <path
                d="M151 78C152.105 78 153 77.1046 153 76C153 74.8954 152.105 74 151 74C149.895 74 149 74.8954 149 76C149 77.1046 149.895 78 151 78Z"
                fill="#E66819"
            />
            <path
                d="M139 103C139 101.343 140.343 100 142 100H168C169.657 100 171 101.343 171 103V124C171 125.657 169.657 127 168 127H142C140.343 127 139 125.657 139 124V103Z"
                fill="#404040"
            />
            <path d="M145.978 108.5H171H145.978Z" fill="#404040" />
            <path
                d="M150.022 110.533L147.376 113.519C146.505 114.502 147.244 116 148.601 116H161.399C162.627 116 163.397 114.745 162.786 113.738L159.769 108.76C159.227 107.865 157.915 107.735 157.189 108.506L155.139 110.68C154.573 111.279 153.61 111.356 152.947 110.854L152.247 110.324C151.568 109.811 150.58 109.904 150.022 110.533Z"
                fill="#818181"
            />
            <path
                d="M151 108C152.105 108 153 107.105 153 106C153 104.895 152.105 104 151 104C149.895 104 149 104.895 149 106C149 107.105 149.895 108 151 108Z"
                fill="#E66819"
            />
            <path
                d="M102 73C102 71.3431 103.343 70 105 70H131C132.657 70 134 71.3431 134 73V94C134 95.6569 132.657 97 131 97H105C103.343 97 102 95.6569 102 94V73Z"
                fill="white"
            />
            <path d="M108.978 78.5H134H108.978Z" fill="white" />
            <path
                d="M107 92H120"
                stroke="#E66819"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M128 92H129"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M113.022 80.5332L110.376 83.519C109.505 84.5023 110.244 86 111.601 86H124.399C125.627 86 126.397 84.7455 125.786 83.7382L122.769 78.7599C122.227 77.8647 120.915 77.7355 120.189 78.5056L118.139 80.6797C117.573 81.2794 116.61 81.3559 115.947 80.8538L115.247 80.3241C114.568 79.8107 113.58 79.9035 113.022 80.5332Z"
                fill="#818181"
            />
            <path
                d="M114 78C115.105 78 116 77.1046 116 76C116 74.8954 115.105 74 114 74C112.895 74 112 74.8954 112 76C112 77.1046 112.895 78 114 78Z"
                fill="#E66819"
            />
            <path
                d="M102 103C102 101.343 103.343 100 105 100H131C132.657 100 134 101.343 134 103V124C134 125.657 132.657 127 131 127H105C103.343 127 102 125.657 102 124V103Z"
                fill="#404040"
            />
            <path d="M108.978 108.5H134H108.978Z" fill="#404040" />
            <path
                d="M113.022 110.533L110.376 113.519C109.505 114.502 110.244 116 111.601 116H124.399C125.627 116 126.397 114.745 125.786 113.738L122.769 108.76C122.227 107.865 120.915 107.735 120.189 108.506L118.139 110.68C117.573 111.279 116.61 111.356 115.947 110.854L115.247 110.324C114.568 109.811 113.58 109.904 113.022 110.533Z"
                fill="#818181"
            />
            <path
                d="M114 108C115.105 108 116 107.105 116 106C116 104.895 115.105 104 114 104C112.895 104 112 104.895 112 106C112 107.105 112.895 108 114 108Z"
                fill="#E66819"
            />
            <mask
                id="mask0_46_1429"
                style={{
                maskType: "luminance",
                }}
                maskUnits="userSpaceOnUse"
                x={29}
                y={13}
                width={141}
                height={50}
            >
                <path
                d="M165.645 13H33.3555C30.9522 13 29.0039 14.1813 29.0039 15.6385V60.3615C29.0039 61.8187 30.9522 63 33.3555 63H165.645C168.048 63 169.996 61.8187 169.996 60.3615V15.6385C169.996 14.1813 168.048 13 165.645 13Z"
                fill="white"
                />
            </mask>
            <g mask="url(#mask0_46_1429)">
                <path
                d="M165.644 13H33.3553C30.9519 13 29.0037 14.1813 29.0037 15.6385V60.3615C29.0037 61.8187 30.9519 63 33.3553 63H165.644C168.048 63 169.996 61.8187 169.996 60.3615V15.6385C169.996 14.1813 168.048 13 165.644 13Z"
                fill="#404040"
                />
                <path
                d="M50.3116 40.333L43.0345 47.7975C40.6379 50.2558 42.672 54 46.404 54H81.598C84.975 54 87.0906 50.8637 85.4121 48.3456L77.1152 35.8998C75.6232 33.6617 72.0173 33.3387 70.0198 35.2641L64.3815 40.6993C62.8263 42.1986 60.1774 42.3898 58.353 41.1344L56.4285 39.8102C54.5633 38.5267 51.8462 38.7589 50.3116 40.333Z"
                fill="#818181"
                />
                <path
                d="M55.4998 31C58.5373 31 60.9998 28.5376 60.9998 25.5C60.9998 22.4624 58.5373 20 55.4998 20C52.4622 20 49.9998 22.4624 49.9998 25.5C49.9998 28.5376 52.4622 31 55.4998 31Z"
                fill="#E66819"
                />
                <path d="M179.352 13H98.4119V63H179.352V13Z" fill="white" />
                <path
                d="M109.073 29.0952H134.095"
                stroke="#404040"
                strokeWidth={2}
                strokeLinecap="round"
                />
                <path
                d="M109.073 35H148.673"
                stroke="#B7B7B7"
                strokeWidth={2}
                strokeLinecap="round"
                />
                <path
                d="M128.003 41H140.187"
                stroke="#B7B7B7"
                strokeWidth={2}
                strokeLinecap="round"
                />
                <path
                d="M109.073 41H122.998"
                stroke="#B7B7B7"
                strokeWidth={2}
                strokeLinecap="round"
                />
                <path
                d="M130.276 48H108.724C107.772 48 107 48.584 107 49.3043V52.6957C107 53.416 107.772 54 108.724 54H130.276C131.228 54 132 53.416 132 52.6957V49.3043C132 48.584 131.228 48 130.276 48Z"
                fill="#E66819"
                />
                <path d="M114 51H124.668" stroke="white" strokeLinecap="round" />
                <path
                d="M157.276 48H135.724C134.772 48 134 48.584 134 49.3043V52.6957C134 53.416 134.772 54 135.724 54H157.276C158.228 54 159 53.416 159 52.6957V49.3043C159 48.584 158.228 48 157.276 48Z"
                fill="#767676"
                />
                <path d="M141 51H151.668" stroke="white" strokeLinecap="round" />
            </g>
            <g clipPath="url(#clip1_46_1429)">
                <path
                d="M164.237 22.0378L162.655 23.4029L163.137 25.4444C163.163 25.5552 163.156 25.6715 163.117 25.7784C163.078 25.8853 163.007 25.9782 162.915 26.0452C162.823 26.1123 162.713 26.1505 162.599 26.1551C162.485 26.1596 162.373 26.1303 162.275 26.0709L160.5 24.9783L158.724 26.0709C158.626 26.13 158.514 26.159 158.4 26.1543C158.286 26.1495 158.177 26.1113 158.085 26.0443C157.993 25.9773 157.923 25.8846 157.883 25.7779C157.844 25.6711 157.837 25.5551 157.863 25.4444L158.347 23.4029L156.765 22.0378C156.679 21.9634 156.617 21.8654 156.586 21.7559C156.555 21.6464 156.558 21.5303 156.593 21.4221C156.628 21.3139 156.694 21.2184 156.783 21.1475C156.872 21.0766 156.979 21.0335 157.093 21.0235L159.167 20.8562L159.967 18.9198C160.01 18.8142 160.084 18.724 160.179 18.6604C160.274 18.5969 160.385 18.563 160.499 18.563C160.613 18.563 160.725 18.5969 160.819 18.6604C160.914 18.724 160.988 18.8142 161.031 18.9198L161.831 20.8562L163.905 21.0235C164.019 21.0331 164.127 21.076 164.216 21.1468C164.305 21.2176 164.372 21.3131 164.407 21.4214C164.442 21.5298 164.444 21.6461 164.414 21.7558C164.383 21.8655 164.321 21.9637 164.235 22.0381L164.237 22.0378Z"
                fill="#E66819"
                />
            </g>
            <g clipPath="url(#clip2_46_1429)">
                <path
                d="M168.576 74.2429L167.697 75.0013L167.965 76.1355C167.98 76.1971 167.976 76.2617 167.954 76.3211C167.932 76.3805 167.893 76.4321 167.842 76.4693C167.791 76.5065 167.729 76.5278 167.666 76.5303C167.603 76.5329 167.54 76.5166 167.486 76.4836L166.5 75.8765L165.513 76.4836C165.459 76.5164 165.397 76.5325 165.333 76.5299C165.27 76.5272 165.209 76.506 165.158 76.4688C165.107 76.4316 165.068 76.3801 165.046 76.3208C165.024 76.2615 165.02 76.197 165.035 76.1355L165.304 75.0013L164.425 74.2429C164.377 74.2016 164.343 74.1472 164.326 74.0863C164.309 74.0255 164.31 73.961 164.329 73.9009C164.349 73.8408 164.385 73.7877 164.435 73.7483C164.484 73.709 164.544 73.685 164.607 73.6795L165.759 73.5865L166.204 72.5107C166.228 72.4521 166.269 72.4019 166.322 72.3666C166.374 72.3313 166.436 72.3125 166.499 72.3125C166.563 72.3125 166.625 72.3313 166.677 72.3666C166.73 72.4019 166.771 72.4521 166.795 72.5107L167.239 73.5865L168.392 73.6795C168.455 73.6848 168.515 73.7086 168.564 73.7479C168.614 73.7873 168.651 73.8403 168.67 73.9005C168.69 73.9607 168.691 74.0253 168.674 74.0863C168.657 74.1472 168.623 74.2018 168.575 74.2431L168.576 74.2429Z"
                fill="#E66819"
                />
            </g>
            <g clipPath="url(#clip3_46_1429)">
                <path
                d="M130.576 74.2429L129.697 75.0013L129.965 76.1355C129.98 76.1971 129.976 76.2617 129.954 76.3211C129.932 76.3805 129.893 76.4321 129.842 76.4693C129.791 76.5065 129.729 76.5278 129.666 76.5303C129.603 76.5329 129.54 76.5166 129.486 76.4836L128.5 75.8765L127.513 76.4836C127.459 76.5164 127.397 76.5325 127.333 76.5299C127.27 76.5272 127.209 76.506 127.158 76.4688C127.107 76.4316 127.068 76.3801 127.046 76.3208C127.024 76.2615 127.02 76.197 127.035 76.1355L127.304 75.0013L126.425 74.2429C126.377 74.2016 126.343 74.1472 126.326 74.0863C126.309 74.0255 126.31 73.961 126.329 73.9009C126.349 73.8408 126.385 73.7877 126.435 73.7483C126.484 73.709 126.544 73.685 126.607 73.6795L127.759 73.5865L128.204 72.5107C128.228 72.4521 128.269 72.4019 128.322 72.3666C128.374 72.3313 128.436 72.3125 128.499 72.3125C128.563 72.3125 128.625 72.3313 128.677 72.3666C128.73 72.4019 128.771 72.4521 128.795 72.5107L129.239 73.5865L130.392 73.6795C130.455 73.6848 130.515 73.7086 130.564 73.7479C130.614 73.7873 130.651 73.8403 130.67 73.9005C130.69 73.9607 130.691 74.0253 130.674 74.0863C130.657 74.1472 130.623 74.2018 130.575 74.2431L130.576 74.2429Z"
                fill="#E66819"
                />
            </g>
            <g clipPath="url(#clip4_46_1429)">
                <path
                d="M93.576 74.2429L92.6971 75.0013L92.9648 76.1355C92.9796 76.1971 92.9758 76.2617 92.9539 76.3211C92.932 76.3805 92.893 76.4321 92.8418 76.4693C92.7906 76.5065 92.7295 76.5278 92.6662 76.5303C92.6029 76.5329 92.5403 76.5166 92.4863 76.4836L91.5 75.8765L90.5131 76.4836C90.4591 76.5164 90.3965 76.5325 90.3334 76.5299C90.2702 76.5272 90.2093 76.506 90.1582 76.4688C90.1071 76.4316 90.0681 76.3801 90.0462 76.3208C90.0243 76.2615 90.0205 76.197 90.0351 76.1355L90.3039 75.0013L89.425 74.2429C89.3772 74.2016 89.3426 74.1472 89.3256 74.0863C89.3086 74.0255 89.3099 73.961 89.3293 73.9009C89.3487 73.8408 89.3854 73.7877 89.4348 73.7483C89.4842 73.709 89.5441 73.685 89.607 73.6795L90.7594 73.5865L91.2039 72.5107C91.228 72.4521 91.2689 72.4019 91.3215 72.3666C91.3742 72.3313 91.4361 72.3125 91.4995 72.3125C91.5629 72.3125 91.6248 72.3313 91.6775 72.3666C91.7301 72.4019 91.771 72.4521 91.7951 72.5107L92.2394 73.5865L93.3918 73.6795C93.4548 73.6848 93.5149 73.7086 93.5645 73.7479C93.6141 73.7873 93.6509 73.8403 93.6705 73.9005C93.69 73.9607 93.6913 74.0253 93.6743 74.0863C93.6573 74.1472 93.6227 74.2018 93.5748 74.2431L93.576 74.2429Z"
                fill="#E66819"
                />
            </g>
            <g clipPath="url(#clip5_46_1429)">
                <path
                d="M57.576 74.2429L56.6971 75.0013L56.9648 76.1355C56.9796 76.1971 56.9758 76.2617 56.9539 76.3211C56.932 76.3805 56.893 76.4321 56.8418 76.4693C56.7906 76.5065 56.7295 76.5278 56.6662 76.5303C56.6029 76.5329 56.5403 76.5166 56.4863 76.4836L55.5 75.8765L54.5131 76.4836C54.4591 76.5164 54.3965 76.5325 54.3334 76.5299C54.2702 76.5272 54.2093 76.506 54.1582 76.4688C54.1071 76.4316 54.0681 76.3801 54.0462 76.3208C54.0243 76.2615 54.0205 76.197 54.0351 76.1355L54.3039 75.0013L53.425 74.2429C53.3772 74.2016 53.3426 74.1472 53.3256 74.0863C53.3086 74.0255 53.3099 73.961 53.3293 73.9009C53.3487 73.8408 53.3854 73.7877 53.4348 73.7483C53.4842 73.709 53.5441 73.685 53.607 73.6795L54.7594 73.5865L55.2039 72.5107C55.228 72.4521 55.2689 72.4019 55.3215 72.3666C55.3742 72.3313 55.4361 72.3125 55.4995 72.3125C55.5629 72.3125 55.6248 72.3313 55.6775 72.3666C55.7301 72.4019 55.771 72.4521 55.7951 72.5107L56.2394 73.5865L57.3918 73.6795C57.4548 73.6848 57.5149 73.7086 57.5645 73.7479C57.6141 73.7873 57.6509 73.8403 57.6705 73.9005C57.69 73.9607 57.6913 74.0253 57.6743 74.0863C57.6573 74.1472 57.6227 74.2018 57.5748 74.2431L57.576 74.2429Z"
                fill="#E66819"
                />
            </g>
            </g>
            <defs>
            <clipPath id="clip0_46_1429">
                <rect width={200} height={117} fill="white" />
            </clipPath>
            <clipPath id="clip1_46_1429">
                <rect width={9} height={9} fill="white" transform="translate(156 18)" />
            </clipPath>
            <clipPath id="clip2_46_1429">
                <rect width={5} height={5} fill="white" transform="translate(164 72)" />
            </clipPath>
            <clipPath id="clip3_46_1429">
                <rect width={5} height={5} fill="white" transform="translate(126 72)" />
            </clipPath>
            <clipPath id="clip4_46_1429">
                <rect width={5} height={5} fill="white" transform="translate(89 72)" />
            </clipPath>
            <clipPath id="clip5_46_1429">
                <rect width={5} height={5} fill="white" transform="translate(53 72)" />
            </clipPath>
            </defs>
        </svg>
    )
}

export default Multiple;